<template>

  <v-dialog
    :value="visiblePopup"
    :max-width="330"
    @click:outside="onCancelButton"
    @keydown.esc="onCancelButton"
  >
    <v-card class="popup-wrapper">
      <div class="title">{{$t(title)}}</div>
      <div class='select-tld'>
        <Select
          class-name="domain-select"
          v-model="selectedDomain"
          :options="listOfDomains"
          :title="$t('configuration.add.url.associate.tld')"
          :placeholder="$t('select')"
          size="small"
        />
      </div>
      <div class="buttons">
        <v-btn small depressed class="no-button btn-secondary" @click="onCancelButton()">
          {{ $t('cancel') }}
        </v-btn>
        <v-btn small depressed class="yes-button btn-primary" @click="onOkClickButton()">
          {{saveButtonTitle}}
        </v-btn>
      </div>
    </v-card>
  </v-dialog>

</template>

<script>

import { mapGetters } from 'vuex';
import Select from '@/components/common/Select.vue';
import disableOuterScrollOnPopupVisible from '@/mixins/disableOuterScrollOnPopupVisible';

export default {
  name: 'EditTldPopup',
  mixins: [disableOuterScrollOnPopupVisible],
  props: {
    currentSelectedTld: {
      required: false,
    },
    item: {
      required: true,
    },
    title: String,
    label: String,
    isHost: {
      type: Boolean,
      default: false,
    },
    saveButtonTitle: String,
    visiblePopup: {
      type: Boolean,
      required: true,
    },
  },
  components: {
    Select,
  },
  data() {
    return {
      selectedDomain: this.currentSelectedTld || '',
    };
  },
  computed: {
    ...mapGetters(['domains', 'configurationDomains']),
    listOfDomains() {
      const domainsSet = new Set(this.domains);
      this.configurationDomains.forEach(configurationDomain => domainsSet.add(configurationDomain.configData));
      let domainsArray = Array.from(domainsSet);
      if (!this.isHost && this.item) {
        const itemValue = this.item.configData ? this.item.configData : this.item;
        const tempDomainsList = [];
        domainsArray.forEach(domain => {
          if (itemValue.endsWith(`.${domain}`) || itemValue === domain) {
            tempDomainsList.push(domain);
          }
        });
        domainsArray = tempDomainsList;
      }
      return domainsArray;
    },
  },
  methods: {
    async onOkClickButton() {
      await this.$emit('changed', this.selectedDomain);
      this.onCancelButton();
    },
    onCancelButton() {
      this.$emit('cancel');
    },
  },
};
</script>

<style lang="scss" scoped>
@import '~@/assets/styles/design-system';

.popup-wrapper {
  max-width: rem(380);
  padding: $space-8 $space-4;

  // Double-class to override Vuetify's .v-application .title (1.25rem) global rule
  .title.title {
    color: var(--text-primary);
    font-size: 0.8rem;
    font-weight: 600;
    letter-spacing: 0;
    line-height: rem(20);
    padding-bottom: rem(23);
    text-transform: uppercase;
  }

  .select-tld {
    // Space between label text and the dropdown input
    ::v-deep span {
      display: block;
      margin-bottom: $space-2;
      line-height: normal;
    }

    // Ensure dropdown input has white background in light mode
    ::v-deep .el-input__inner {
      background-color: var(--bg-primary);
    }
  }

  .message {
    font-size: $font-size-base;
    line-height: 1.36;
    font-weight: normal;
    color: var(--text-primary);
    letter-spacing: 0;
  }

  .buttons {
    text-align: right;
    padding-top: rem(30);

    .no-button.no-button {
      box-sizing: border-box;
      height: $btn-height-md;
      width: rem(86);
      border: $border-width-thin solid var(--brand-primary);
      color: var(--brand-primary);
      border-radius: $radius-sm;
      background-color: var(--bg-primary);
      box-shadow: $shadow-sm;
    }

    .yes-button.yes-button {
      height: $btn-height-md;
      width: rem(51);
      border-radius: $radius-sm;
      background-color: var(--brand-primary);
      box-shadow: $shadow-sm;
      color: var(--text-inverse);
      font-size: $font-size-sm;
      font-weight: 500;
      letter-spacing: 1.07px;
      line-height: rem(16);
      text-align: center;
      margin-left: $space-2;
    }
  }
}

</style>
